<template>
    <div class="recommendation-list">
      <div v-if="!recommendations || recommendations.length === 0" class="text-center py-3">
        <p class="text-muted">{{ $t('No recommendations available.') }}</p>
      </div>
      
      <b-card-group v-else columns>
        <b-card
          v-for="recommendation in recommendations"
          :key="recommendation.id"
          class="mb-3"
          border-variant="success"
        >
          <b-card-title>
            <font-awesome-icon :icon="['fa', 'lightbulb']" class="text-warning mr-2" />
            {{ $t('Recommendation') }} #{{ recommendation.id }}
          </b-card-title>
          
          <b-card-text>
            {{ recommendation.description }}
          </b-card-text>
          
          <b-list-group flush v-if="recommendation.details && recommendation.details.length">
            <b-list-group-item v-for="(detail, index) in recommendation.details" :key="index">
              {{ detail }}
            </b-list-group-item>
          </b-list-group>
          
          <template v-slot:footer>
            <b-button
              variant="outline-primary"
              size="sm"
              @click="toggleFavorite(recommendation)"
            >
              <font-awesome-icon :icon="['fa', recommendation.favorite ? 'star' : 'star-o']" />
              {{ recommendation.favorite ? $t('Favorited') : $t('Add to Favorites') }}
            </b-button>
          </template>
        </b-card>
      </b-card-group>
      
      <div class="d-flex justify-content-end mt-3">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="exportRecommendations"
          v-if="recommendations.length > 0"
        >
          <font-awesome-icon :icon="['fa', 'download']" />
          {{ $t('Export') }}
        </b-button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'RecommendationList',
    props: {
      recommendations: {
        type: Array,
        default: () => []
      }
    },
    methods: {
        $t(text) {
      // Simple passthrough function until proper i18n is set up
      return text;
    },
      toggleFavorite(recommendation) {
        // This would normally update a favorited field in Firestore
        // For now, we'll just update the local state
        recommendation.favorite = !recommendation.favorite;
      },
      
      exportRecommendations() {
        const recommendationData = this.recommendations.map(rec => ({
          'Recommendation #': rec.id,
          'Description': rec.description,
          'Details': rec.details ? rec.details.join('; ') : ''
        }));
        
        // Convert to CSV
        const headers = Object.keys(recommendationData[0]);
        const csvContent = [
          headers.join(','),
          ...recommendationData.map(row => headers.map(header => {
            // Escape quotes and wrap in quotes
            const cell = row[header].toString();
            return `"${cell.replace(/"/g, '""')}"`;
          }).join(','))
        ].join('\n');
        
        // Create download link
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'recommendations.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };
  </script>
  
  <style scoped>
  .recommendation-list {
    margin-bottom: 1rem;
  }
  </style>